import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const AccountNotActive = () => {
  const { t } = useTranslation();

  return (
    <Grid container flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" gap={3}>
      <img src="/images/logos/monkeybook-light.png" alt="Monkeybook" style={{ width: 180, objectFit: 'contain' }} />
      <Typography variant="body1" color="text.secondary" textAlign="center">
        {t('accountNotActive.message')}
      </Typography>
    </Grid>
  );
};
